import { SaiQuickTourStep } from 'app/ui/sai-quick-tour/sai-quick-tour.types';

/** Organization Hierarchy tab index on `/pages/profile` (0-based). */
export const PROFILE_HIERARCHY_TAB_INDEX = 3;

/** Canonical 13-step SAI Quick Tour for first-time org admins. */
export const SAI_QUICK_TOUR_STEPS: readonly SaiQuickTourStep[] = [
    {
        id: 'welcome',
        titleKey: 'SAI Quick Tour — Welcome',
        bodyKey: 'You are on the Dashboard. This is your home base — KPIs, agents, and reports at a glance.',
        route: '/overview',
        centered: true,
        placement: 'center',
    },
    {
        id: 'profile',
        titleKey: 'Open your Profile',
        bodyKey: 'Click Profile in the sidebar under your organization name to manage company settings.',
        route: '/pages/profile',
        target: '[data-sai-tour="nav-profile"]',
        placement: 'right',
    },
    {
        id: 'hierarchy-tab',
        titleKey: 'Organization Hierarchy',
        bodyKey: 'Open the Organization Hierarchy tab to structure divisions and departments.',
        route: '/pages/profile',
        queryParams: { tabIndex: String(PROFILE_HIERARCHY_TAB_INDEX) },
        target: '[data-sai-tour="profile-hierarchy-tab"]',
        placement: 'bottom',
    },
    {
        id: 'add-division',
        titleKey: 'Add a division',
        bodyKey: 'Click Add Division, enter a name (for example Finance), and click Add.',
        route: '/pages/profile',
        queryParams: { tabIndex: String(PROFILE_HIERARCHY_TAB_INDEX) },
        target: '[data-sai-tour="add-division"]',
        placement: 'bottom',
    },
    {
        id: 'add-department',
        titleKey: 'Add a department',
        bodyKey: 'Expand a division, click the + button, enter a Department Name, and click Add.',
        route: '/pages/profile',
        queryParams: { tabIndex: String(PROFILE_HIERARCHY_TAB_INDEX) },
        target: '[data-sai-tour="add-department"]',
        placement: 'left',
    },
    {
        id: 'data-sources-nav',
        titleKey: 'Data Sources',
        bodyKey: 'Click Data Sources in the sidebar to connect spreadsheets and documents.',
        permissionKey: 'data_source',
        target: '[data-sai-tour="nav-datasources"]',
        placement: 'right',
    },
    {
        id: 'add-data-source',
        titleKey: 'Create a data source',
        bodyKey: 'Click Add Data Source, enter a name, select the department you created, then save.',
        permissionKey: 'data_source',
        route: '/data-sources',
        target: '[data-sai-tour="add-data-source"]',
        placement: 'bottom',
    },
    {
        id: 'upload-data',
        titleKey: 'Upload your data',
        bodyKey: 'Open a data source and upload a file — CSV or XLSX for tables, or documents for file-based sources.',
        permissionKey: 'data_source',
        route: '/data-sources',
        centered: true,
        placement: 'center',
    },
    {
        id: 'agents-nav',
        titleKey: 'SAI Agents',
        bodyKey: 'Click SAI Agents in the sidebar to build AI assistants on top of your data.',
        permissionKey: 'agents',
        target: '[data-sai-tour="nav-ai-agents"]',
        placement: 'right',
    },
    {
        id: 'add-agent',
        titleKey: 'Create an agent',
        bodyKey: 'Click Add Agent, name it, link your data source, and add brief instructions.',
        permissionKey: 'agents',
        route: '/ai-agents',
        target: '[data-sai-tour="add-agent"]',
        placement: 'bottom',
    },
    {
        id: 'chat-nav',
        titleKey: 'Try SAI Chat',
        bodyKey: 'Open SAI Chat in the sidebar, pick your agent, and ask it a question.',
        target: '[data-sai-tour="nav-chatForAgent"]',
        placement: 'right',
    },
    {
        id: 'tracker-nav',
        titleKey: 'Explore Tracker',
        bodyKey: 'Open Tracker to turn your data into charts and KPIs.',
        permissionKey: 'trackers',
        target: '[data-sai-tour="nav-tracker"]',
        placement: 'right',
    },
    {
        id: 'complete',
        titleKey: 'You are all set!',
        bodyKey: 'Main flow: Department → Data → Agent → Chat → Tracker. You can replay this tour anytime from Profile settings.',
        route: '/overview',
        centered: true,
        placement: 'center',
    },
];
